import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Revisione53StoreModule } from './store/revisione53-store.module';
import { Revisione53Service } from './revisione53.service';
import { Revisione53MainContainerComponent } from './components/main-container/revisione53-main-container.component';
import { RouterModule } from '@angular/router';
import { SalvaSuServerComponent } from './components/main-container/salva-su-server/salva-su-server.component';
import { CaricaDaPcComponent } from './components/main-container/carica-da-pc/carica-da-pc.component';
import { DatiIdentificativiFormModule } from './forms/dati-identificativi/dati-identificativi-form.module';
import { DatiBilancioFormModule } from './forms/dati-bilancio/dati-bilancio-form.module';
import { NaturaMutualisticaFormModule } from './forms/natura-mutualistica/natura-mutualistica-form.module';
import { InviaVerbaleComponent } from './components/main-container/invia-verbale/invia-verbale.component';
import { FormErrorsDebugComponent } from './components/main-container/form-errors-debug/form-errors-debug.component';
import { ContribBiennaleFormModule } from './forms/contrib-biennale/contrib-biennale-form.module';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { ScopoSocialeFormModule } from './forms/scopo-sociale/scopo-sociale-form.module';
import { ContribLegge5992FormModule } from './forms/contrib-legge-59-92/contrib-legge-59-92-form.module';
import { BaseSocialeFormModule } from './forms/base-sociale/base-sociale-form.module';
import { SchedaSettoreFormModule } from './forms/scheda-settore/scheda-settore-form.module';
import { DatiBilancioBisFormModule } from './forms/dati-bilancio-bis/dati-bilancio-bis-form.module';
import { AmminControlloFormModule } from './forms/amm-controllo/ammin-controllo-form.module';
import { AltreNotLibriSocFormModule } from './forms/altre-not-libri-soc/altre-not-libri-soc-form.module';
import { ConclusioniFormModule } from './forms/conclusioni/conclusioni-form.module';
import { SezIIAccertamentoFormModule } from './forms/sez-II-accertamento/sez-ii-accertamento-form.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FormOrchestratorService } from './form-service-orchestrator/form-orchestrator.service';
import { FormSettlingService } from './form-service-orchestrator/form-settling.service';
import { REVISIONE53_FORM_SERVICE_PROVIDERS } from './form-service-orchestrator/consts/form-orchestrator.const';
import { SharedModule } from '@shared/shared.module';

@NgModule({
    declarations: [Revisione53MainContainerComponent, SalvaSuServerComponent, CaricaDaPcComponent, InviaVerbaleComponent, FormErrorsDebugComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        Revisione53StoreModule,
        RouterModule,
        DatiIdentificativiFormModule,
        DatiBilancioFormModule,
        DatiBilancioBisFormModule,
        NaturaMutualisticaFormModule,
        ContribBiennaleFormModule,
        NaturaMutualisticaFormModule,
        ScopoSocialeFormModule,
        ContribLegge5992FormModule,
        BaseSocialeFormModule,
        SchedaSettoreFormModule,
        AmminControlloFormModule,
        ConclusioniFormModule,
        AltreNotLibriSocFormModule,
        SezIIAccertamentoFormModule,
        NgxSmartModalModule.forChild(),
        SharedModule,
    ],
    exports: [Revisione53MainContainerComponent],
    providers: [Revisione53Service, FormOrchestratorService, FormSettlingService, ...REVISIONE53_FORM_SERVICE_PROVIDERS],
})
export class Revisione53CoreModule {}
